import { type FC, type PropsWithChildren } from "react";
import { useParams } from "react-router";

import type { GenomeStatistics } from "@/graphql.ts";
import { GenomicAnnotationsContext } from "@/modules/summary-pages/AnnotationsContext.ts";
import {
  useFetchGenomeAnnotationStatistics,
  useFetchGenomeProteinStatistics,
} from "@/ui-modules/entities/genomes/graphql/useFetchGenomeStatistics.ts";

export const GenomicAnnotationsProvider: FC<PropsWithChildren> = ({ children }) => {
  const { genomeId } = useParams<"genomeId">();
  const genomeIdNum = Number(genomeId);

  // GenomicAnnotationCard.tsx
  const genomeStatisticsQuery = useFetchGenomeAnnotationStatistics({ genomeId: genomeIdNum });

  // GenomicProteinContentCard.tsx
  const proteinStatisticsQuery = useFetchGenomeProteinStatistics({ genomeId: genomeIdNum });

  if (!genomeId) {
    return null;
  }

  const contextValue = {
    genomicAnnotations: genomeStatisticsQuery,
    proteinStatistics: { ...proteinStatisticsQuery, data: proteinStatisticsQuery.data as GenomeStatistics },
  };

  return <GenomicAnnotationsContext.Provider value={contextValue}>{children}</GenomicAnnotationsContext.Provider>;
};
